import type { CSSProperties } from "react";

/**
 * Permissive inline-style helper. The ClearFlow kit styles with CSS custom
 * properties (e.g. `fontWeight: "var(--fw-semibold)"`, `zIndex: "var(--z-modal)"`)
 * which strict `CSSProperties` value unions reject. `sx` accepts a loose record
 * and narrows it back to `CSSProperties` for the consumer. Component *props*
 * stay fully typed — only the internal token-string styles are widened.
 */
export const sx = (s: Record<string, unknown>): CSSProperties => s as CSSProperties;
